import React from 'react';
import style from './style.scss';
import {Select} from 'components/partials/select';

class AdvancedSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {ten: 'option 1', value: 1},
        {ten: 'option 2', value: 2},
        {ten: 'option 3', value: 3},
        {ten: 'option 4', value: 4},
        {ten: 'option 5', value: 5}
      ]
    }
  }

  render() {
    return (
      <section className="advanced-search">
        <div className='wrap-advanced-search'>
          <h2 className='advanced-search-title'>Tìm kiếm nâng cao</h2>
          <Select data={this.state.data} placeHolder='Thành phố' text='ten' keyName='value'/>
          <Select data={this.state.data} placeHolder='Loại người bán' text='ten' keyName='value'/>
          <Select data={this.state.data} placeHolder='Thành viên' text='ten' keyName='value'/>
          <Select data={this.state.data} placeHolder='Độ phổ biến' text='ten' keyName='value'/>
        </div>
      </section>
    );
  }
}

export default AdvancedSearch;



// WEBPACK FOOTER //
// ./components/list-product/advanced-search/AdvancedSearch.jsx